import { createFileRoute } from "@tanstack/react-router";
import { AnalyticsPage } from "@/components/settings/analytics-page";

export const Route = createFileRoute("/_dashboard/settings")({
  component: AnalyticsPage,
});
